var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "example" }, [
    _c(
      "div",
      { staticClass: "interaction" },
      [
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("h3", [_vm._v(_vm._s(_vm.actionTitle))]),
            _vm._v(" "),
            _c(
              "sweet-button",
              { attrs: { color: "pink" }, on: { click: _vm.dispatchAction } },
              [_vm._v("Try out")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "code" },
      [
        _vm.$slots.code
          ? _c("sweet-code", { attrs: { language: _vm.language } }, [
              _c("code", { class: _vm.language }, [_vm._t("code_sanitized")], 2)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.code
          ? _c("sweet-code", { attrs: { language: _vm.language } }, [
              _c("code", {
                class: _vm.language,
                domProps: { innerHTML: _vm._s(_vm.code_sanitized) }
              })
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03069cc1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03069cc1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./docs/components/Example.vue
// module id = 232
// module chunks = 0